var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.displayLoading ? _c('Loading') : [_c('div', {
    staticClass: "page"
  }, [_vm.getModuleConfig('terms_page.step_section.enable_step_section') ? _c('div', {
    staticClass: "p-3"
  }, [_c('SharedStep', {
    attrs: {
      "steps": _vm.getModuleConfig('terms_page.step_section.steps')
    }
  })], 1) : _vm._e(), _vm.getModuleConfig('terms_page.form_title') ? _c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("terms_page.form_title")) + " ")]) : _vm._e(), _vm.getModuleConfig('terms_page.form_desc') ? _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("terms_page.form_desc")) + " ")]) : _vm._e(), _vm._l(_vm.terms, function (term, index) {
    return _c('div', {
      key: index,
      class: index == 0 ? 's-mb-8' : ''
    }, [_c('Accordion', {
      attrs: {
        "title": term.title
      }
    }, [_c('div', {
      staticClass: "term-vhtml",
      domProps: {
        "innerHTML": _vm._s(term.text)
      }
    })]), _c('Checkbox', {
      attrs: {
        "name": 'checkbox' + index
      },
      model: {
        value: _vm.checked[index],
        callback: function callback($$v) {
          _vm.$set(_vm.checked, index, $$v);
        },
        expression: "checked[index]"
      }
    }, [_vm._v(_vm._s(term.checkbox_text))])], 1);
  })], 2), _c('div', {
    staticClass: "page__button"
  }, [_c('Button', {
    staticClass: "s-btn-bg-primary",
    attrs: {
      "disabled": !_vm.isAllChecked()
    },
    on: {
      "click": _vm.goNextPage
    }
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("terms_page.button_text")) + " ")])], 1)]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }